import { Injectable } from '@angular/core';
import { Choice } from '../components/select/choice.model';
import { BasicService } from './basic.service';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor(private basicService: BasicService) {}

  /**
   * Get an array of numbers, from start to end included
   * @example
   * intRange(3,8); returns [3,4,5,6,7,8]
   */
  intRange(start: number, end: number): number[] {
    return [...Array(end - start + 1).keys()].map(i => start + i);
  }

  intRangeAsChoices(start: number, end: number): Choice[] {
    return this.intRange(start, end).map((id: number) => ({ id, label: `${id}` } as Choice));
  }

  /**
   * Get formatted time from seconds in two ways:
   * with letters (two biggest values from day, hour, minutes, seconds)
   * or hh:mm:ss
   *
   * @param duration in seconds
   * @param isLiteral true if we want to return time with letters ex: 2d 2h
   * @returns formatted time in string
   */
  formatDuration(duration: number, isLiteral: boolean): string {
    if (!duration && duration !== 0) {
      return '';
    }

    const d = Math.floor(duration / (3600 * 24));
    const hNo24Limit = Math.floor(duration / 3600);
    duration -= d * 3600 * 24;

    const h = Math.floor(duration / 3600);
    duration -= h * 3600;

    const m = Math.floor(duration / 60);
    duration -= m * 60;

    const s = Math.floor(duration);

    if (isLiteral) {
      let retval = [];
      if (duration >= 0 && duration < 1) {
        return '0';
      }
      if (d > 0) {
        retval.push(`${d}${this.basicService.translate('metrics/day/short')}`);
      }
      if (h > 0) {
        retval.push(`${h}${this.basicService.translate('hour_short')}`);
      }
      if (m > 0) {
        retval.push(`${m}${this.basicService.translate('minute_short')}`);
      }
      if (s > 0) {
        retval.push(`${s}${this.basicService.translate('second_short')}`);
      }
      if (retval.length > 2) {
        retval = retval.slice(0, 2);
      }
      return retval.join(' ');
    } else {
      const hours = hNo24Limit < 10 ? `0${hNo24Limit}` : hNo24Limit;
      const minutes = m < 10 ? `0${m}` : m;
      const seconds = s < 10 ? `0${s}` : s;

      return `${hours}:${minutes}:${seconds}`;
    }
  }
}
